<template>
  <div>
    <list
      row-key="LogId"
      ref="list"
      unit="售价带出策略"
      :expand-all-row="false"
      :page="false"
      :show-query="false"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>

      <template slot="table">
        <el-table-column
          prop="PriorityLevel"
          label="序号"
          min-width="55px"
          align="center"
        >
          <template slot-scope="{ $index }">
            {{ $index + 1 }}
          </template></el-table-column
        >
        <el-table-column
          prop="SourceName"
          label="售价带出来源"
          align="center"
        />
        <el-table-column
          prop="IsUse"
          label="是否使用"
          align="center"
          min-width="85px"
        >
          <template slot-scope="{ row, $index }">
            <el-checkbox
              @change="toggleIsUse($event, row, $index)"
              v-model="row.IsUse"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="PriorityLevel"
          label="优先级"
          align="center"
          min-width="85px"
        />

        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              :disabled="$index == 0"
              @click="up(row, $index)"
              >上移</el-button
            >
            <el-button
              type="text"
              :disabled="$index + 1 == tableLength"
              @click="down(row, $index)"
              >下移
            </el-button>
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import list from "@/components/common/list";
import listMixin from "@/mixins/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/priceStrategy").default,
      params: {
        PriceStrategyType: 0,
      },
    };
  },
  computed: {
    tableLength() {
      return this.$refs.list.data.length;
    },
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve) => {
        this.api.list({ PriceStrategyType: 0 }).then((res) => {
          resolve(res);
        });
      });
    },
    toggleIsUse(data, item, index) {
      this.api.save({ ...item }).then((res) => {
        if (res.Code === 0) {
          this.$message.success(res.Msg);
        }
      });
    },
    rest() {
      this.$refs.list.data.forEach((item) => {
        this.api
          .save({ ...item, PriorityLevel: item.PriceStrategyId })
          .then((sub) => {
            if (sub.Code === 0) {
              this.$message.success(res.Msg);
            }
          });
      });
    },
    up(row, index) {
      if (index > 0) {
        let down = this.$refs.list.data[index - 1];
        // down.sn += 1;
        down.PriorityLevel += 1;
        // this.$refs.list.data[index].sn -= 1;
        this.$refs.list.data[index].PriorityLevel -= 1;
        this.$refs.list.data.splice(index - 1, 1);
        this.$refs.list.data.splice(index, 0, down);

        console.log("up", this.$refs.list.data[index - 1]);
        console.log("current", this.$refs.list.data[index]);
        // console.log('down',...this.$refs.list.data[index+1]);
        this.api.save(this.$refs.list.data[index]).then((res) => {
          if (res.Code === 0) {
            this.api.save(this.$refs.list.data[index - 1]).then((sub) => {
              if (sub.Code === 0) {
                this.$message.success(res.Msg);
              }
            });
          }
        });
      } else {
        this.$message({
          message: "已经是第一条，上移失败",
          type: "warning",
        });
      }
    },
    down(row, index) {
      if (index + 1 == this.$refs.list.data.length) {
        this.$message({
          message: "已经是最后一条，下移失败",
          type: "warning",
        });
      } else {
        let top = this.$refs.list.data[index + 1];
        // top.sn -= 1;
        top.PriorityLevel -= 1;
        // this.$refs.list.data[index].sn += 1;
        this.$refs.list.data[index].PriorityLevel += 1;
        this.$refs.list.data.splice(index + 1, 1);
        this.$refs.list.data.splice(index, 0, top);
        this.api.save(this.$refs.list.data[index]).then((res) => {
          if (res.Code === 0) {
            this.api.save(this.$refs.list.data[index + 1]).then((sub) => {
              if (sub.Code === 0) {
                this.$message.success(res.Msg);
              }
            });
          }
        });
      }
    },
  },
};
</script>
